import React from 'react';
import { Ticket, CreditCard, Calendar, Bus, Info } from 'lucide-react';

const BENEFICIOS = [
    { label: 'Cinemas e Teatros', text: 'Meia-entrada em sessões e espetáculos pelo país.', icon: Ticket, color: '#E91E63' },
    { label: 'Shows e Festivais', text: 'Pague metade em eventos musicais participantes.', icon: CreditCard, color: '#9C27B0' },
    { label: 'Eventos Esportivos', text: 'Descontos em jogos e competições oficiais.', icon: Calendar, color: '#4CAF50' },
    { label: 'Transporte', text: 'Benefícios estudantis onde houver convênio.', icon: Bus, color: '#FF9800' },
];

export default function BeneficiosEAutenticacao() {
    return (
        <>
            <div className="vc-shead">
                <div className="vc-shead__left">
                    <span className="vc-shead__num">01</span>
                    <div>
                        <div className="vc-shead__eyebrow">Seus benefícios</div>
                        <h2 className="vc-shead__title">Meia-entrada em todo o país</h2>
                    </div>
                </div>
                <p className="vc-shead__desc">
                    Sua carteira digital tem validade nacional e garante meia-entrada onde o benefício é aceito.
                </p>
            </div>

            <div className="vc-features">
                {BENEFICIOS.map(({ label, text, icon: Icon, color }) => (
                    <div className="vc-feature" key={label}>
                        <div className="vc-feature__ic" style={{ background: `${color}15`, color }}>
                            <Icon size={24} />
                        </div>
                        <div className="vc-feature__label">{label}</div>
                        <div className="vc-feature__text">{text}</div>
                    </div>
                ))}
            </div>

            <div className="vc-tip">
                <Info size={20} color="#006adc" style={{ flex: '0 0 auto', marginTop: 1 }} />
                <div className="vc-tip__text">
                    <strong>Dica:</strong> baixe o PDF ou tire um print da carteirinha — assim você usa o benefício mesmo sem internet no local do evento.
                </div>
            </div>
        </>
    );
}
